export default __webpack_public_path__ + "static/media/23_1_2.6b2cf754.png";